















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { performanceServer } from '@/api/installServer';
import ViewItSonDialog from '@/views/inspectionContents/checklist/unit/viewItSonDialog.vue';
import publishObjectPath from '@/util/configRegistry';
import Axios from 'axios';

@Component({
  components: { ViewItSonDialog },
  filters: {
    changeState(state: any) {
      switch (state) {
        case 'CREATED':
          return '已创建';
          break;
        case 'ISSUE':
          return '已下发';
          break;
        case 'RECTIFYING':
          return '整改中';
          break;
        case 'RECTIFIED':
          return '整改完成';
          break;
        case 'FEEDBACK_ALREADY':
          return '已反馈';
          break;
        case 'FINISH':
          return '已完成';
          break;
        case 'REVIEW_FAIL':
          return '复查不通过';
          break;
      }
    },
  },
})
export default class CheckRectification extends Vue {
  @Prop(Object) rowId: any;
  basicData: any = []; // 刚进入整改单页面的时候获取到的最上方表格的数据；[{},{},{}]
  hazardsTable: any = [];
  stateStyle: any = 'state1';
  hiddenDanger: any = [];
  formData: any = {};
  currentIndex = 0;
  // 隐藏的逻辑：如果放在缓存里的helpHazards里面有一个rectifyFormId === '' 则显示
  isShowCreateOrder = true; // 创建整改单按钮的显示隐藏
  staffIdCurrent = '';

  /**
   * 返回
   * */
  private backToIndex() {
    this.$emit('backToIndex');
  }

  rectifyFormRes() {
    this.getRectifyFormDetail();
    this.getTemplateDetailData();
  }

  created() {
    const info: any = localStorage.getItem('userInfo');
    const userInfo = JSON.parse(info);
    this.staffIdCurrent = userInfo.staffId;
    this.getRectifyFormDetail();
    this.getTemplateDetailData();
  }

  // 获取整改单和基础信息
  getRectifyFormDetail() {
    performanceServer.getRectifyFormDetail(this.rowId.id).then((res: any) => {
      if (res.code === '200') {
        this.basicData = res.data; // 展示全部的基础信息的表格的数据（根据左侧的整改单进行切换）
        if (this.basicData.length) {
          this.formData = this.basicData[0]; // 刚进入页面时候展示第一项
          this.getRectifyForm(this.basicData[0].id);
        }
        // 左侧整改单的数据
        this.hiddenDanger = res.data.map((item: any, index: any) => {
          return {
            name: '整改单' + (index + 1),
            state: item.status,
            stateStyle: this.changeState11(item.status),
          };
        });
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  // 获取 隐患信息的表格数据
  private getRectifyForm(id: any) {
    performanceServer.getRectifyForm(id).then((res: any) => {
      if (res.code === '200') {
        this.hazardsTable = res.data.hazards.length ? res.data.hazards : [];
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  // 详情的接口（判断是否显示创建整改单按钮）
  private getTemplateDetailData() {
    performanceServer.getTemplateDetail(this.rowId.id).then((res: any) => {
      if (res.code === '200') {
        // localStorage.setItem('helpHazards', JSON.stringify(res.data.hazards));
        this.isShowCreateOrder = res.data.hazards.some((res: any) => !res.rectifyFormId) && res.data.createStaffId === this.staffIdCurrent;
      } else {
        this.$message.warning(res.mag);
      }
    });
  }

  // 创建整改单
  private createOrder() {
    const viewItSonDialog = 'viewItSonDialog';
    const viewItSonDialogComponent = this.$refs[viewItSonDialog];
    (viewItSonDialogComponent as any).showDialog(this.rowId.id); // fixMe：这里是传给弹窗的数据
  }

  private changeState11(state: any) {
    switch (state) {
      case 'CREATED':
        return '#ff0000';
        break;
      case 'ISSUE':
        return '#FF8ADCFF';
        break;
      case 'RECTIFYING':
        return '#666';
        break;
      case 'RECTIFIED':
        return '整改完成';
        break;
      case 'FEEDBACK_ALREADY':
        return '已反馈';
        break;
      case 'FINISH':
        return '已完成';
        break;
      case 'REVIEW_FAIL':
        return '复查不通过';
        break;
    }
  }

  private cutOverInfo(index: any) {
    // 点击不同的整改单，展示不同的基础信息和隐患信息的数据
    // 默认展示的是第一条数据
    this.formData = this.basicData[index];
    this.currentIndex = index;
    this.getRectifyForm(this.basicData[index].id);
    localStorage.setItem('wuWuWu', this.basicData[index].id);
  }

  private exportLoading = false; // 导出的加载
  private serverUrl = publishObjectPath.serverUrl;

  // 打印
  private printMethod() {
    this.$confirm('确定导出整改单记录？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.exportLoading = true;
        this.exportExcelApi();
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        });
      });
  }

  private exportExcelApi() {
    // 服务加载的动画
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    Axios.defaults.headers.Authorization = localStorage.getItem('token');
    Axios({
      method: 'POST',
      url: this.serverUrl + `/api/yunnan/security-check/rectify-form/export/rectify-feedback-from/${this.basicData[this.currentIndex].id}`, // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
    })
      .then(response => {
        // const disposition = response.headers["Content-disposition"];
        console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '导出文件';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
        loading.close();
        this.exportLoading = false;
        this.$message({
          type: 'success',
          message: '导出成功!',
        });
      })
      .catch(error => {
        loading.close();
        this.$message({
          type: 'error',
          message: '导出失败,请联系管理员!',
        });
        console.log(error);
      });
  }
}
